import { removeParamsFromQuery, toParams } from '@marketplace-web/shared/utils'
import { ProductItemModel } from '@marketplace-web/item-box/product-item-data'

const BUNDLE_TRACKING_ID_URL_PARAM = 'bundle_id'

export const getBundleTrackingIdUrlParam = (urlQuery: string): string | null => {
  const param = toParams(urlQuery)[BUNDLE_TRACKING_ID_URL_PARAM]

  if (Array.isArray(param)) return null

  return param || null
}

export const removeBundleTrackingIdUrlParam = (relativeUrl: string, urlQuery: string) =>
  removeParamsFromQuery(relativeUrl, urlQuery, [BUNDLE_TRACKING_ID_URL_PARAM])

export const getIsBundlingAllowed = ({
  item,
  bundleItems,
  selectedItemId,
}: {
  item: ProductItemModel
  bundleItems: Array<ProductItemModel>
  selectedItemId?: number
}) => {
  if (!selectedItemId) return true

  // switching from itemDto (selectedItems) to bundleItemDto (bundleItems) and will remove transaction request in the future
  const isPreselectedItemHeavyBulky =
    bundleItems.find(bundleItem => bundleItem.id === selectedItemId)?.isHeavyBulky || false

  return item.isHeavyBulky === isPreselectedItemHeavyBulky
}
